/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/AllVotesResetCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { Components } from "VSS/Platform/Layout";
import { Status, Statuses, StatusSize } from "VSSUI/Status";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";

export const AllVotesResetCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            <Status {...Statuses.Waiting} className="activity-card-first-image" color="neutral" size={StatusSize.l} />
            {Resources.ActivityFeedAllVotesReset}
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.all-votes-reset-activity-card", AllVotesResetCard);
